/**
 * MN Wholesale - VAT Toggle
 * Switches visible product prices between EX VAT and INC VAT.
 */
(function () {
  'use strict';

  var DEFAULT_VAT_RATE = 20;
  var STORAGE_KEY = 'mn_vat_mode';
  var ATTR_ORIGINAL = 'data-mn-vat-original';
  var ATTR_PENCE = 'data-mn-vat-pence';
  var isUpdating = false;
  var observer = null;

  var PRICE_SELECTOR = [
    '.price-item',
    '.price-item .money',
    '.mn-feat__price',
    '.mn-feat__price--was',
    '[data-mn-vat-price]',
    '.product__price .money',
    '.card-product .money',
    '.sticky-atc__price .money',
    '.money-subtotal'
  ].join(',');

  function getMode() {
    try {
      return localStorage.getItem(STORAGE_KEY) || sessionStorage.getItem(STORAGE_KEY) || 'excl';
    } catch (e) {
      return 'excl';
    }
  }

  function setMode(mode) {
    try {
      localStorage.setItem(STORAGE_KEY, mode);
      sessionStorage.setItem(STORAGE_KEY, mode);
    } catch (e) {}
  }

  function parsePence(text) {
    var match = String(text).match(/(\d[\d,]*\.?\d*)/);
    if (!match) return null;
    var amount = parseFloat(match[1].replace(/,/g, ''));
    if (isNaN(amount)) return null;
    return Math.round(amount * 100);
  }

  function formatAmount(pence, decimals) {
    return (pence / 100).toLocaleString('en-GB', {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals
    });
  }

  function formatText(original, pence) {
    var decimals = /\d[\d,]*\.\d{1,2}/.test(original) ? 2 : 2;
    return original.replace(/(\d[\d,]*\.?\d*)/, formatAmount(pence, decimals));
  }

  function priceContext(el) {
    var context = el.closest('[data-vat-rate]');
    if (context) return context;

    var productContext = el.closest('.productView-details, .productView, .halo-quickView, [data-sticky-add-to-cart]');
    return productContext ? productContext.querySelector('[data-vat-rate]') : null;
  }

  function vatRateFor(el) {
    var context = priceContext(el);
    if (!context) return DEFAULT_VAT_RATE;
    if (context.getAttribute('data-vat-free') === 'true') return 0;
    var rate = parseFloat(context.getAttribute('data-vat-rate'));
    return isNaN(rate) ? DEFAULT_VAT_RATE : rate;
  }

  function storeOriginal(el) {
    if (el.hasAttribute(ATTR_ORIGINAL)) return;
    var text = el.textContent;
    var pence = parsePence(text);
    if (pence === null || pence <= 0) return;
    el.setAttribute(ATTR_ORIGINAL, text);
    el.setAttribute(ATTR_PENCE, String(pence));
  }

  function storeOriginals() {
    document.querySelectorAll(PRICE_SELECTOR).forEach(storeOriginal);
  }

  function updateLabels(mode) {
    document.querySelectorAll('[data-vat-label]').forEach(function (label) {
      var context = label.closest('[data-vat-rate]') || label.previousElementSibling;
      if (context && context.getAttribute('data-vat-free') === 'true') {
        label.textContent = 'VAT free';
        return;
      }
      var rate = context ? parseFloat(context.getAttribute('data-vat-rate')) : DEFAULT_VAT_RATE;
      if (!rate) {
        label.textContent = 'VAT free';
        return;
      }
      var suffix = /per unit/i.test(label.textContent) ? ' per unit' : '';
label.textContent = mode === 'incl' ? '\u00A0\u00A0inc VAT' + suffix : '\u00A0ex VAT' + suffix;    });
  }

  function updateHeadings(mode) {
    document.querySelectorAll('[data-vat-heading]').forEach(function (heading) {
      heading.textContent = mode === 'incl' ? 'TRADE PRICE (INC. VAT)' : 'TRADE PRICE (EX. VAT)';
    });
  }

  function updateCartSidebar(mode) {
    document.querySelectorAll('[data-mn-cart-ex-subtotal]').forEach(function (row) {
      row.style.display = mode === 'incl' ? 'none' : '';
    });
    document.querySelectorAll('[data-mn-cart-inc-subtotal]').forEach(function (row) {
      row.style.display = mode === 'incl' ? '' : 'none';
    });
  }

  function updateToggles(mode) {
    document.querySelectorAll('.mn-vat-toggle').forEach(function (toggle) {
      toggle.setAttribute('data-mode', mode);
      toggle.querySelectorAll('.mn-vat-toggle__btn').forEach(function (btn) {
        btn.setAttribute('aria-pressed', btn.getAttribute('data-mode') === mode ? 'true' : 'false');
      });
      var switchBtn = toggle.querySelector('.mn-vat-toggle__switch');
      if (switchBtn) {
        switchBtn.setAttribute('aria-pressed', mode === 'incl' ? 'true' : 'false');
        switchBtn.setAttribute('data-mode', mode === 'incl' ? 'excl' : 'incl');
        switchBtn.setAttribute('aria-label', mode === 'incl' ? 'Switch to EX VAT' : 'Switch to INC VAT');
      }
    });
  }

  function applyMode(mode) {
    if (isUpdating) return;
    isUpdating = true;
    if (observer) observer.disconnect();

    storeOriginals();

    document.querySelectorAll(PRICE_SELECTOR).forEach(function (el) {
      var original = el.getAttribute(ATTR_ORIGINAL);
      var pence = parseInt(el.getAttribute(ATTR_PENCE), 10);
      if (!original || isNaN(pence)) return;

      var rate = vatRateFor(el);
      var newPence = mode === 'excl' && rate > 0 ? Math.round(pence / (1 + rate / 100)) : pence;
      el.textContent = formatText(original, newPence);
    });

    updateLabels(mode);
    updateHeadings(mode);
    updateCartSidebar(mode);
    updateToggles(mode);
    document.documentElement.setAttribute('data-vat', mode);
    document.body.classList.toggle('mn-vat-incl', mode === 'incl');
    document.body.classList.toggle('mn-vat-excl', mode !== 'incl');

    isUpdating = false;
    if (observer) observer.observe(document.body, { childList: true, subtree: true });
  }

  function bindButtons() {
    document.addEventListener('click', function (event) {
      var btn = event.target.closest('.mn-vat-toggle__btn, .mn-vat-toggle__switch');
      if (!btn) return;
      event.preventDefault();
      var mode = btn.getAttribute('data-mode') === 'incl' ? 'incl' : 'excl';
      setMode(mode);
      applyMode(mode);
    });
  }

  function startObserver() {
    observer = new MutationObserver(function (mutations) {
      if (isUpdating) return;
      var hasNewNodes = mutations.some(function (mutation) {
        return mutation.addedNodes.length > 0;
      });
      if (hasNewNodes) applyMode(getMode());
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function init() {
    if (window.mnVatToggleEnabled === false) return;
    var mode = getMode();
    if (mode !== 'incl') mode = 'excl';
    applyMode(mode);
    bindButtons();
    startObserver();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
